/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dropdown } from "react-bootstrap";
import SntSortAZ from "@icons/SntSortAZ";
import SntSortZA from "@icons/SntSortZA";
import { LanguageKey } from "@/types/generated/LanguageKey";
import { translate } from "@/hooks/useLanguage";

interface SortActionsProps {
  column: any;
  toggleSortBy: (columnKey: string, desc: boolean) => void;
}

export const SortActions = ({ column, toggleSortBy }: SortActionsProps) => {
  if (column.disableSortBy) return null;

  return (
    <>
      <Dropdown.Header>{translate(LanguageKey.columm_actions_key)}</Dropdown.Header>
      <Dropdown.Item
        bsPrefix="dropdown-item"
        onClick={() => toggleSortBy(column.columnKey, false)}
      >
        <div className="d-flex">
          <div style={{ width: 20 }} className="d-flex align-items-center">
            <SntSortAZ />
          </div>
          <div>{translate(LanguageKey.sort_az_key)}</div>
        </div>
      </Dropdown.Item>
      <Dropdown.Item
        bsPrefix="dropdown-item"
        onClick={() => toggleSortBy(column.columnKey, true)}
      >
        <div className="d-flex">
          <div style={{ width: 20 }} className="d-flex align-items-center">
            <SntSortZA />
          </div>
          <div>{translate(LanguageKey.sort_za_key)}</div>
        </div>
      </Dropdown.Item>
      <Dropdown.Divider className="table-group-menu-divider" />
    </>
  );
};
